import { StyleSheet } from '@react-pdf/renderer'
//import logo from '../../images/MegaLogo.png';

export default StyleSheet.create({
  
    /*page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4'
      },
      section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
      },*/

    page: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  contentSection: {
    /*background: `linear-gradient(
        rgba(255, 255, 255, 0.9),
        rgba(255, 255, 255, 0.9)
      ),
      url(${logo})
        center`,
    backgroundSize: 'cover',
    backgroundImage: {logo},
    backgroundRepeat: 'repeat',*/
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    position: 'relative',
    fontSize: '10px',
    marginTop: '15px',
    flex: '8',
  },
  watermarkSection: {
    
  },
  watermarkView: {
    width: '100%',
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  watermark: {
    color: 'rgba(0, 0, 0, 0.05)',
    //fontSize: `${8 * props.scale}rem`,
    //fontWeight: 'bold',
    //textTransform: 'uppercase',
    transform: 'rotate(-45deg)',
    fontSize: '10px',
    userSelect: 'none',
    margin: '30px',
    
  },
  contentView: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  infoView: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    margin: '5px 10px',
    border: '1px solid gray',
    borderRadius: '10px',
    padding: '5px',
  },
  detailsView: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    margin: '5px 10px',
    border: '1px solid gray',
    borderRadius: '10px',
    padding: '5px',
  },
  approvalsView: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    margin: '5px 10px',
    border: '1px solid gray',
    borderRadius: '10px',
    padding: '5px',
  },
  rowView: {
    minWidth: '46%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '1px 5px',
    
  },
  textTitle: {
    marginRight: '5px',
    fontFamily: 'Helvetica-Bold',
  },
  textContent: {
  },
  detailsTitleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    fontFamily: 'Helvetica-Bold',
    //borderBottom: '1px solid bold',
  },
  detailsContentRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '2px',
    //borderBottom: '1px normal gray',
  },
  detailsSummaryRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    fontFamily: 'Helvetica-Bold',
  },
  detailsSNoColumn: {
      width: '10%',
      paddingLeft: '5px',
  },
  detailsDescColumn: {
    width: '65%',
  },
  detailsAmountColumn: {
    width: '25%',
    textAlign: 'right',
    paddingRight: '5px',
  },

  
})